import React, { useState } from "react";
import Modal from "react-modal";

const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

const validateName = (name) => {
  return name.trim() !== "";
};

const validatePhone = (phone) => {
  const regex = /^\d{10}$/;
  return regex.test(phone);
};

const FormModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const isEmailValid = validateEmail(email);
    const isNameValid = validateName(name);
    const isPhoneValid = validatePhone(phone);
    if (isEmailValid && isNameValid && isPhoneValid) {
      const info = { phone, email, name };
      onClose(info);
    } else {
      if (!isEmailValid) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
      if (!isNameValid) {
        setNameError("Please enter your full name");
      } else {
        setNameError("");
      }
      if (!isPhoneValid) {
        setPhoneError("Please enter a 10-digit phone number");
      } else {
        setPhoneError("");
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="  w-[90vw] h-fit   tab-port:w-fit tab-port:h-fit px-[2em] py-[4em]    text-center absolute tab-port:px-[8em] tab-port:py-[3em] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl tab-port:p-6"
      overlayClassName="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50"
    >
      <h2 className="tab-port:text-4xl text-5xl font-bold mb-10">
        Ingrese lo siguiente:
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-8 tab-port:mb-6">
          <label
            htmlFor="email"
            className="block text-gray-700 font-medium text-4xl tab-port:text-2xl mb-2 "
          >
            Correo Electrónico
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border  text-4xl tab-port:text-2xl border-gray-400 rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          {emailError && (
            <div className="text-red-600 text-sm mt-1">{emailError}</div>
          )}
        </div>

        <div className="mb-8 mb-6">
          <label
            htmlFor="name"
            className="block text-gray-700 text-4xl tab-port:text-2xl font-medium mb-2 "
          >
            Nombre Completo
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border text-4xl tab-port:text-2xl border-gray-400 rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          {nameError && (
            <div className="text-red-600 text-sm mt-1">{nameError}</div>
          )}
        </div>

        <div className="mb-8 mb-6">
          <label
            htmlFor="phone"
            className="block text-gray-700 text-4xl tab-port:text-2xl font-medium mb-2"
          >
            Numero Telefónico
          </label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            className="w-full border text-4xl tab-port:text-2xl border-gray-400 rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
          {phoneError && (
            <div className="text-red-600 text-sm mt-1">{phoneError}</div>
          )}
        </div>
        <button
          className="my-4 tab-port:text-2xl text-4xl px-10 py-8 bg-[#003676] tab-port:px-8 tab-port:py-6 rounded-full text-white font-bold"
          type="submit"
        >
          Submit
        </button>
      </form>
    </Modal>
  );
};

export default FormModal;
